angular.module('moebiusProadapt').controller('ctrlLogsIndex',
    ['$timeout','$rootScope', '$scope', '$http', '$location', 'logsResolver', '$uibModal', 'promiseTracker', function($timeout,$rootScope, $scope, $http, $location, logsResolver, $uibModal, promiseTracker){
        $scope.logs = logsResolver.logs;

        $scope.getContext = (json) => {
            let data = JSON.parse(json);
            return JSON.stringify(data, null, "     ");
        }
    }]
);



// WEBPACK FOOTER //
// ./resources/assets/js/controllers/logs/logsIndex.js